import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch, faAngleLeft, faAngleRight, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Vue from 'vue';

Vue.component('fa-icon', FontAwesomeIcon);

library.add(faSearch);
library.add(faAngleRight);
library.add(faAngleLeft);
library.add(faQuestionCircle);
library.add(faChevronUp);
